exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-left-status[data-v-8c75f6aa] {\n  margin-right: 5px;\n}\n", ""]);

// exports
